module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main products feature"
  }, [_c('div', {
    staticClass: "bannerBackground"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('f-title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "mainContent"
  }, [_c('div', {
    staticClass: "feature-part key-features"
  }, [_c('div', {
    staticClass: "feature-info"
  }, [_c('p', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro key-feature-intro"
  }, [_c('ul', {
    staticClass: "key-feature-lists"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list1-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list1-detail')))])]), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list2-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list2-detail')))])]), _vm._v(" "), _c('li', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list3-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list3-detail')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "key-feature-lists"
  }, [_c('li', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list4-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list4-detail')))])]), _vm._v(" "), _c('li', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list5-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list5-detail')))])]), _vm._v(" "), _c('li', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list6-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list6-detail')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "key-feature-lists"
  }, [_c('li', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list7-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list7-detail')))])]), _vm._v(" "), _c('li', [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list8-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list8-detail')))])]), _vm._v(" "), _c('li', [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('feature-list9-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('feature-list9-detail')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "feature-info other-features"
  }, [_c('p', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('other-feature')))])]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro key-feature-intro"
  }, [_c('ul', {
    staticClass: "key-feature-lists"
  }, [_c('li', [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('other-list1-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('other-list1-detail')))])]), _vm._v(" "), _c('li', [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "feature-title title"
  }, [_vm._v(_vm._s(_vm.$t('other-list2-title')))]), _vm._v(" "), _c('div', {
    staticClass: "feature-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('other-list2-detail')))])]), _vm._v(" "), _c('li')])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_chat@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_voicecalls@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_conferencecall@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_synced@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_vioce@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_sharing@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_clouddrive@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_batchsend@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_burn@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_apps@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_search@2x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9931f86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feature/Feature.vue
// module id = 303
// module chunks = 1